<gl-base-modal (closeModal)="onClose()">
  <h2 class="title">{{ 'download_pdf' | translate }}</h2>
  <form [formGroup]="form">
    <label class="nameLabel">{{'project_name' | translate}}</label>
    <gl-input-container>
      <input type="text" normal-input formControlName="name" />
    </gl-input-container>
    <div [class.dataWrapper]="data">
      @if (data) {
        <div class="textarea-wrapper">
          <div class="screenDescription">{{ 'pdf_screen_description' | translate }}:</div>
          <img class="projection" [src]="imageSrc" />
        </div>
      }
      <div class="textarea-wrapper">
        <div class="projectNotes">{{ 'project_notes' | translate }}:</div>
        <textarea class="textarea" formControlName="note" maxlength="500"></textarea>
      </div>
    </div>
    @if (isUserAuthorized) {
      <div class="checkbox">
        <gl-checkbox formControlName="saveOption" [defaultChecked]="true">{{
          'overwrite_changes' | translate
        }}</gl-checkbox>
      </div>
    }
    <button class="button" id="pdf" normal-outline-button (click)="onSubmit()">
      {{ 'download_pdf' | translate }}
    </button>
    @if (project.workSpaces.length > 1) {
      <div class="checkbox">
        <gl-checkbox formControlName="downloadPdfForAllLoading" [defaultChecked]="false">{{
          'download_for_all_loading' | translate
        }}</gl-checkbox>
      </div>
    }
  </form>
</gl-base-modal>
